module.exports = __webpack_public_path__ + "static/media/SampleHotline.fd931a61.png";